export const defaultMonitoringProposalValidationResults = {
  updated: false,
  about: {
    state_quality_id: true,
    pressure_quality_id: true,
    response_quality_id: true,
    state_evaluation: true,
    pressure_evaluation: true,
    response_evaluation: true
  },
  siteState: { result: true, benchmarkIds: [] },
  sitePressure: { result: true, threatIds: [] },
  siteResponse: {
    designation_pa_id: true,
    designation_oecms_id: true,
    designation_pa_oecms_id: true,
    response_planning_id: true,
    response_action_id: true,
    actions_needed_count: true,
    actions_underway_count: true
  }
}
